import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import DrillDownDonut from 'components/molecules/charts/DrillDownDonut';
import ExpandedDonutTable from 'components/molecules/tables/ExpandedDonutTable';

class ExpandedDonut extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data) || !isEqual(nextProps.total, this.props.total);
    }


    render() {
        const { bucketPercentage, exportName, data, inverted, title, total, totalFormat, totalTitle, y,
            donutCaption } = this.props;
        const donutProps = { bucketPercentage, data, title, total, totalFormat, totalTitle, y, donutCaption };
        const tableProps = { data, y, title, total };
        const donutEle = <Col xs={12} lg={6}>
            <DrillDownDonut {...donutProps} exportName={`${exportName}-donut`} />
        </Col>;
        const tableEle = <Col xsHidden smHidden mdHidden lg={6}>
            <ExpandedDonutTable {...tableProps} exportName={`${exportName}-table`} />
        </Col>;
        return (
            <Row>
                {!inverted ? (
                    <React.Fragment>
                        {donutEle}
                        {tableEle}
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {tableEle}
                        {donutEle}
                    </React.Fragment>
                )}
            </Row>
        );
    }
}

ExpandedDonut.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        y: PropTypes.number.isRequired,
        color: PropTypes.string
    })).isRequired,
    title: PropTypes.string.isRequired,
    total: PropTypes.number.isRequired,
    totalTitle: PropTypes.string.isRequired,
    totalFormat: PropTypes.string.isRequired,
    exportName: PropTypes.string.isRequired,
    y: PropTypes.string.isRequired
};

export default withTheme(ExpandedDonut);



// WEBPACK FOOTER //
// ./src/components/molecules/ExpandedDonut.js